/**
 * Room rules (design document §2). A room is either a solo practice against
 * bots or a custom session that needs at least two humans; either way it is
 * created on demand and disappears when its match ends.
 */
export const ROOM_RULES = {
  practice: { minBots: 1, maxBots: 4 },
  custom: { minHumans: 2, maxHumans: 10, maxBots: 5 },
  /** Seconds an unstarted room waits for players before it closes. */
  waitSeconds: 600,
} as const;

export type RoomMode = "practice" | "custom";

/** The largest room: a full custom session. The cage table is calibrated up to here. */
export const MAX_FIGHTERS = ROOM_RULES.custom.maxHumans + ROOM_RULES.custom.maxBots;

/** A session PIN: four digits. It keeps strangers out of a short match; it is not security. */
export function isPin(value: unknown): value is string {
  return typeof value === "string" && /^\d{4}$/.test(value);
}

export function isFighterCount(value: unknown): value is number {
  return (
    typeof value === "number" && Number.isInteger(value) && value >= 2 && value <= MAX_FIGHTERS
  );
}

/**
 * Protocol version: bump when a control message shape changes. Binary layout
 * changes are caught automatically by `WIRE_HASH` (packages/protocol/wire.ts).
 */
export const PROTOCOL_VERSION = 5;

export interface MatchConfig {
  /** Fighters the cage is sized for (the number of fighters in the match). */
  sessionSize: number;
  /** Seed for the simulation's RNG; chosen by the room. */
  seed: number;
}
